import { LitElement, html, ref, css, createRef, utils } from '@hh/global.js'
const { debounce } = utils
class HHPredictiveSearch extends LitElement {
  $form = createRef()

  constructor() {
    super()

    this.route = '/search'
    this.cachedResults = {}
    this.form = this.querySelector('form')
    this.input = this.querySelector('.header-search__input')
    this.results = this.querySelector('.main-search__results container')
    this.clearButton = this.querySelector('.header-search__clear')
    this.suggestionButtons = this.querySelectorAll('.search-modal__suggested button')
    this.setupEventListeners()

  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this))
    this.input.addEventListener('focus', this.onFocus.bind(this))
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )

    this.suggestionButtons.forEach((button) => {
      button.addEventListener(
        'click',
        ((event) => {
          event.preventDefault()
          this.input.nextElementSibling.style.transform = "translateY(-9px)";
          if (button.dataset.term.length) {
            this.input.value = button.dataset.term
            this.updateTermButtonState(button)
            this.onChange(event)

          }
        }).bind(this)
      )
    })

  }


  getQuery() {
    return this.input.value.trim()
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault()
  }

  onFocus() {
    console.log('test')
    const searchTerm = this.getQuery()
    if (!searchTerm.length) return
    if (this.getAttribute('results') === 'true') {
      this.open()
    } else {
      this.getResult(searchTerm)
    }

  }

  updateTermButtonState(button) {
    if (this.getQuery() === button.dataset.term) {
      button.setAttribute('disabled', true)
    }
  }

  onChange() {
    console.log('change')
    const searchTerm = this.getQuery()

    if (!searchTerm.length) {
      this.close(true)
      return
    }

    if (searchTerm.length < 3) {
      this.close()
      return
    }

    const url = new URL(window.location)
    url.searchParams.set('q', searchTerm)
    url.searchParams.delete('page')
    window.history.pushState({}, '', url)

    this.resetSuggestions()
    this.getResult(searchTerm)
  }

  resetSuggestions() {
    this.suggestionButtons.forEach((button) => {
      if (this.getQuery() !== button.dataset.term) {
        button.removeAttribute('disabled')
      }
    })
  }

  onClear() {
    this.input.value = ""
    this.onChange()
  }

  getResult(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    if (this.cachedResults[queryKey]) {
      this.renderResults(this.cachedResults[queryKey])
      return
    }

    fetch(
      `${this.route}?q=${encodeURIComponent(searchTerm)}&section_id=main-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.results').innerHTML
        this.cachedResults[queryKey] = resultsMarkup
        this.renderResults(resultsMarkup)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  renderResults(resultsMarkup) {
    this.querySelector('#searchresults-container').innerHTML = resultsMarkup
    this.setAttribute('results', true)

    this.setLiveRegionResults()
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true)
  }

  setLiveRegionResults() {
    this.removeAttribute('loading')
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }

  render() {
    return html`
          <slot name="heading"></slot>
          <slot name="form" @clearSearch="${this.onClear}"></slot>
          <slot name="suggestion"></slot>
          <slot name="results"></slot>
          `
  }


}

customElements.define('hh-predictive-search', HHPredictiveSearch)
